import type { LineChartSeries } from "../../../shared/components/LineChart";

export const droppedRequestSeries: LineChartSeries[] = [
	{
		name: "Round Robin (RR)",
		points: [
			{ x: 0, y: 0 },
			{ x: 3, y: 0 },
			{ x: 7, y: 3 },
			{ x: 9, y: 7 },
			{ x: 12, y: 10 },
			{ x: 18, y: 23 },
			{ x: 23, y: 31 },
			{ x: 24, y: 31 },
			{ x: 25, y: 34 },
			{ x: 26, y: 34 },
			{ x: 29, y: 39 },
			{ x: 32, y: 42 },
			{ x: 40, y: 54 },
			{ x: 43, y: 56 },
			{ x: 48, y: 63 },
			{ x: 54, y: 75 },
			{ x: 56, y: 76 },
			{ x: 59, y: 80 },
		],
		color: "var(--chart-orange)",
		legendLabel: "Round Robin",
	},
	{
		name: "Weighted Round Robin (WRR)",
		points: [
			{ x: 0, y: 0 },
			{ x: 5, y: 2 },
			{ x: 10, y: 7 },
			{ x: 17, y: 8 },
			{ x: 24, y: 16 },
			{ x: 30, y: 17 },
			{ x: 32, y: 20 },
			{ x: 42, y: 26 },
			{ x: 46, y: 31 },
			{ x: 51, y: 32 },
			{ x: 55, y: 35 },
			{ x: 59, y: 35 },
		],
		color: "var(--chart-blue)",
		texture: "dashed",
		legendLabel: "Weighted Round Robin",
	},
	{
		name: "Least Connections (LC)",
		points: [
			{ x: 0, y: 0 },
			{ x: 11, y: 0 },
			{ x: 12, y: 2 },
			{ x: 15, y: 3 },
			{ x: 16, y: 5 },
			{ x: 31, y: 5 },
			{ x: 35, y: 7 },
			{ x: 41, y: 7 },
			{ x: 42, y: 9 },
			{ x: 46, y: 9 },
			{ x: 49, y: 11 },
			{ x: 58, y: 11 },
			{ x: 59, y: 12 },
		],
		color: "var(--chart-green)",
		texture: "dotted",
		legendLabel: "Least Connections",
	},
];
